<template>
  <v-card
    :loading="loading"
  >
    <v-card-title style="font-size:1em;" v-if="properties">
      <span>
        {{ mapTitle }}
      </span>
      <v-spacer />
      <map-var-selector style="max-width:425px"/>
      <!--help section="map"></help-->
    </v-card-title>
     <!-- <DownloadButton @clicked="download" /> -->

      <div
        id="mapid"
        ref="mapContainer"
      />
  </v-card>
</template>
<script>
import chroma from 'chroma-js'
import {highlight} from '@/utils/utils'
import leafletImage from 'leaflet-image'

import {lightLayer, initMap, featureColor, getColor } from '@/utils/map.js'
import 'leaflet/dist/leaflet.css'
//import DownloadButton from '@/components/DownloadButton.vue'

import L from 'leaflet'

//import leafletEasyprint from 'leaflet-easyprint'
import { mapState, mapGetters } from 'vuex'
import MapVarSelector from './MapVarSelector.vue'
import { risQScores } from '../utils/risq_score'
import { SocialScores } from '../utils/social_score'


export default {
  components: { MapVarSelector,
  // DownloadButton
   },
  data() {
    return {
        a3Size: {
        width: 4000,
        className: 'a3',
        tooltip: 'A custom A3 size',
        name: 'a3'
},
      legend: null,
    //   printPlugin: null,
      button: null,
      map: null,
      pointLayer: null,
      isochroneLayer: null,
      currentRadius: null,
    }
  },

  computed: {
    mapUrl() {
        let map = document.querySelector('canvas.leaflet-zoom-animated');
        let mapUrl = map.toDataURL()
        return mapUrl
    },
    legendRange() {
      return this.scoreObject.legendRange
    },
    scoreObject() {
      return this.mapMode == 'rscore' ? risQScores : SocialScores
    },
    mapTitle() {
      if (this.locationGroup) {
        return `${this.properties ? this.properties.length : ''}  Locations`
      } else if (this.cusip) {
        return `${this.properties ? this.properties.length : ''}  Properties ${ this.cusip ? ` for ${this.cusip}` : ''}`
      }
    },
    mapNeedsToBeInitialized() {
      return this.map === null && this.properties
      // return true
    },
    subscoreTypes() {
      return ['hurricane', 'flood', 'wildfire']
    },
    ...mapGetters(['isClimate','summaryScoreLabel','featuredSubscoreTypes']),
    ...mapState({
      cusip: (state) => state.currentCusip,
      results: (state) => state.currentCusipData,
      summary: (state) => state.summaryData,
      properties: (state) => state.propertyData,
      mapPoints: (state) => state.mapPoints,
      loading: (state) => state.loading,
      driveTimeOptions: (state) => state.driveTimeOptions,
      selectedProperty: (state) => state.selectedProperty,
      showDriveTimeTable: (state) => state.showDriveTimeTable,
      isochrones: (state) => state.isochrones,
      isochroneScores: (state) => state.isochroneScores,
      mapMode: (state) => state.mapMode,
      mapMetric: (state) => state.mapMetric,
      labels: (state) => state.labels,
      powerpointData: (state) => state.powerpointData
    })
  },
  updated: function() {
    if (this.mapNeedsToBeInitialized) {
      const container = this.$refs.mapContainer
      this.initMap(container)
      this.updateMap()
      new ResizeObserver(this.handleResize).observe(container)


      }

  },
  props: {
      locationGroup: {
        type: Object,
        default: null
      }
  },
  methods: {

    //  makeButtonIntoLControl(){

    //   this.button = L.control({position: 'topleft'});
    //   let el = document.querySelectorAll('.downloadButton')[0]

    //   this.button.onAdd = function(){
    //      // el = L.DomUtil.get(el)

    //     return el
    //   }
    //   this.button.addTo(this.map)
    // },
    addLegend: function(grades) {

        if (this.legend) {
          this.map.removeControl(this.legend)
        }
        this.legend = L.control({ position: 'bottomright' })
        //let rank = this.valueIsAbsolute ? '(%)' : '<br/>Rank Percentile'
        let title = this.labels[`${this.mapMetric}_score`]
         this.legend.onAdd = function (map) {

            let div = L.DomUtil.create('div', 'inf legend')

            let table = ''
            for (const i in grades) {
              table += `<tr>
              <td style="width:20px;background-color:${map.component.scoreObject.getColor(grades[i])};">&nbsp;</td>
              <td>${grades[i].toFixed(1)}</td>
              </tr>`
            }


            let legendHTML = `
              <h3>${title}</h3>
              <table class="l-table">
              ${table}
              </table>
            `;
            div.innerHTML = legendHTML
            return div;
          };
          this.legend.addTo(this.map)

      },

//     download(){

//       this.printPlugin.printMap('CurrentSize', 'MBS ESG Custom Map');
//     },
    initMap: function(el) {
      this.map = initMap(el)

      this.map.invalidateSize()
      this.map.component = this



//     this.printPlugin =  L.easyPrint({
//     exportOnly: true,
//     hidden: true,
//      hideClasses: ['leaflet-control-zoom', 'leaflet-control-layers-toggle', 'leaflet-control-zoom-fullscreen'],
//    hideControlContainer: false,
//     //you need to set tileLayer to be able to set tileWait
//      tileLayer: lightLayer,

//      //without this, map image is empty if you click "download" too quickly
//     tileWait: 400,
//     sizeModes: ['Current', 'A4Landscape', 'A4Portrait', this.a3Size]
//     }),
//       this.printPlugin.addTo(this.map);
    },
    updateMap: function() {
      if (this.pointLayer) {
        this.map.removeLayer(this.pointLayer)
        this.pointLayer = null
      }
      this.addPoints(this.mapPoints).then( points => {
        this.pointLayer = points
      })

      this.addLegend(this.legendRange);
      //need the timeout to wait for DownloadButton to be mounted
      //this.makeButtonIntoLControl()
      //setTimeout(()=> this.makeButtonIntoLControl(), 100)
    },
    pointStyle: function(feature) {
      // TODO: make this variable
      const scoreType = 'total'
      // return { fillColor: feature.properties.rscores.color(scoreType), radius: (4 + (21 * feature.properties.rscores.weight )), weight: 1, opacity: 0.5, color: chroma.mix('black', feature.properties.rscores.color(scoreType)), fillOpacity: 1 }
      return { fillColor: this.featureColor(feature), radius: 5, weight: 1, opacity: 0.5, color: chroma.mix('black', this.featureColor(feature)), fillOpacity: 1 }
    },
    isochroneStyle: function(feature) {
      // TODO: make this variable
      return { fillColor: this.featureColor(feature), weight: 1, opacity: 0.5, color: chroma.mix('black', this.featureColor(feature)), fillOpacity: 0.5 }
    },
    addPoints: function(data) {
      return new Promise((resolve, reject) => {
        let points = L.geoJson(data, {
          style: this.pointStyle,
          pointToLayer: function (feature, latlng) {
            // console.log(feature)
            return L.circleMarker(latlng)
          },
          onEachFeature: this.eachPoint
        })
        points.addTo(this.map)
        if (data.length > 1) {
          // only fit the map if more than one point is being plotted, otherwise this will happen in addDriveTimes
          this.map.fitBounds(points.getBounds())
          this.map.invalidateSize()
        }
        resolve(points)
      })
    },
    featureColor(feature) {
      return featureColor(feature,this.mapMode, this.mapMetric)
    },
    getColor(val) {
      return getColor(val,this.mapMode)
    },
    highlight(mode, type){


       if(this.mapMode == 'rscore'&& mode[type]>risQScores.orangePoint){


        return  `<div class="highlight" style="${highlight(risQScores.getTextColor(mode[type]),'50px','5%','95%', '100deg','85%')}">${mode[type]}</div>`
       }
       else {
       return `<div style="padding: 5px 10px" >${mode[type]}</div>`
       }
    },
    popupBody(feature) {
      let body = ''
      this.featuredSubscoreTypes.forEach(type => {
        //feature.properties[`${this.mapMode}s`].toHtml(type)
        body += `
              <tr>
                <td class="subscore">&nbsp;&nbsp;${this.labels[type]}</td>
                <td style="text-align:right;padding-left:10px;"> ${this.highlight(feature.properties[`${this.mapMode}s`], type)} </td>
              </tr>
            `
      })
      return body
    },
    popupContents(feature) {
      return `
          <div class="popup-content">
            <h2 style="border-bottom:1px solid #ccc;">${feature.properties.geoname}</h2>
            <table class="risq-score">
              <tr>
                <td style="font-size:1.25em"><b>${this.summaryScoreLabel}</b></td>
                <td style="font-size:1.25em;text-align:right;padding-left:10px;"><b>${this.highlight(feature.properties[`${this.mapMode}s`], 'total')}</b></td>
              </tr>
              ${this.popupBody(feature)}
            </table>
          </div>
        `
    },
    eachPoint: function(feature, layer) {
      // point click
      const component = this
      layer.on('click', function (e) {
        component.$store.dispatch('updateState', ['selectedProperty', feature.properties]).then(resolution => {
          component.$store.dispatch('fetchIsochrones', feature).then(resolution => {
            layer.closePopup() // closing popup here doesn't really seem to work?
          })
        })
      })
      // bind popup to points
      let popupContents = this.popupContents(feature)
      let popupOptions = {
        autoPan: false,
        autoClose: true,
        keepInView: false,
        offset: [0,0]
      }

      if (this.selectedPoint === feature.properties.id) {
        popupOptions = {
          autoPan: false,
          autoClose: false,
          keepInView: true
        }
        layer.bindPopup(popupContents, popupOptions);
        // This creates a 'Maximum call stack size exceeded' and is a leaflet bug
        // UPDATE: this doesn't appear to be happening anymore
        // https://github.com/Leaflet/Leaflet/issues/5035
        layer.on('add', function(e) { layer.openPopup(); })
        layer.on('remove', function(e) { layer.closePopup(); })
      } else {
        layer.bindPopup(popupContents, popupOptions);
        // polygon mouseover
        layer.on('mouseover', function (e) {
          component.currentRadius = feature.properties.drive_time
          layer.openPopup()
        })
        // polygon mouseout
        layer.on('mouseout', function(e) {
         layer.closePopup();
         component.currentRadius = null

        })
      }
    },
    handleResize: function() {
      this.map.invalidateSize()
      this.map.eachLayer(function(layer) {
        if( layer instanceof L.TileLayer ) {
          layer.redraw();
        }
      });
    },
  },
  watch: {
    locationGroup() {
    },
    mapMetric() {
      this.updateMap()
    },
    mapPoints() {
      if (this.map) {
        this.updateMap()
        this.map.invalidateSize()
      }
    }
  },
  mounted() {
    window.setTimeout(()=> {
        let component = this //inside the function passed to leafletImage, we can't see what 'this' refers to
        leafletImage(this.map,
        function(err, canvas) {
            //the built-in error message is unhelpful; putting this in try/catch block tells us what's actually going wrong if there's an error
            try{
                let url = canvas.toDataURL()
                let powerpointData = component.powerpointData
                powerpointData.mapUrl = url
                component.$store.dispatch('updateState', ['powerpointData', powerpointData]);
            }
            catch(error) {
                console.log(error)
            }
        });
    }, 1000)
  }
}
</script>
<style scoped>



.highlight{
    color:blue;
}
  #mapid {
    height: 430px;
    z-index: 1;
  }
  .popup-content {
    font-size: 0.93em;
  }






</style>


<style>
/* button styles which have to be unscoped,
otherwise leaflet ignores them when the button is
made into an L.Control element */

.downloadButton{
 z-index:300
}
 .legend{

    z-index: 2;
    background-color: rgba(255,255,255,0.5);
    padding: 10px;
    color: #555
  }

  .legend h3 {
    /* less padding causes overflow in downloaded image */
    padding-bottom: 20px;

  }


  .legend table td {
    text-align: right;
    padding-right:10px;
  }

  .legend table.l-table {
    border-spacing: 5px 2px;
}
</style>
